import { Component, OnInit, OnDestroy, HostListener, AfterViewChecked, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs';

import { StorageService } from './core/services/storage.service';
import { LoggingMessageService } from './core/services/logging-message.service';

import { Router } from '@angular/router';
import { WindowEventsService } from './core/services/window-events.service';
import { AuthService } from './core/services/auth.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [FormBuilder]
})

export class AppComponent implements OnInit, AfterViewChecked, OnDestroy {

  @ViewChild('divIndicatorContainer') divIndicatorContainer: ElementRef;

  private $subscriptions: Subscription = new Subscription();
  private applicationVersion = 'if0.0';
  private containerHeight = 0;
  private parentLoaded = false;  

  private subscription = 0;
  availableSubscriptions = new Array<string>();
  get subscriptionSelected(): number {
    return this.subscription;
  }
  set subscriptionSelected(value: number) {
    this.subscription = value;
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(event) {
    this.logger.info('app.component', 'beforeUnloadHander', this.subscriptionSelected, this.availableSubscriptions.join(','), 'saving preferences', '');
    this.storageService.saveUserPreferences();
  }

  constructor(
    private router: Router,
    private windowEvents: WindowEventsService,
    private storageService: StorageService,
    private logger: LoggingMessageService,
    private authService: AuthService,
    private route: ActivatedRoute) {

    this.subscribeNavigationEvents();
    if (window.addEventListener) { // Adding listener from origin
      window.addEventListener('message', this.sizeRequest.bind(this), false);
    }
  }

  ngOnInit() {
    this.logger.debug('app.component', 'ngOnInit', this.subscriptionSelected, this.availableSubscriptions.join(','), 'fired', '');
    this.applicationVersion = environment.applicationVersion;
    this.postWindowMessage();
  }

  private postWindowMessage() {
    setTimeout(() => {
      window.parent.postMessage('indicatorversion:' + this.applicationVersion, '*');
    }, 0);
  }

  ngAfterViewChecked() {
    const currentHeight = this.divIndicatorContainer.nativeElement.scrollHeight;
    if (this.containerHeight !== currentHeight) {
      this.containerHeight = currentHeight; // On height change, inform origin
      if (this.parentLoaded) {
        window.parent.postMessage('sizing:' + document.body.scrollHeight + 100, '*'); // adding buffer of 100px to solve for dropdowns, calendar etc
      }
    }
  }

  public sizeRequest(e: any) {
    if (e.data.toString().includes('sizing')) {
      this.parentLoaded = true;
    }
  }

  private subscribeNavigationEvents() {
    // const user = this.user;
    const navigationSubscription = this.windowEvents.navigationChange$
      .subscribe(path => {
        this.handleNavigation(path);
      });
    this.$subscriptions.add(navigationSubscription);
  }

  private handleNavigation(path: string) {
    this.logger.info('app.component', 'handleNavigation',  this.subscriptionSelected, this.availableSubscriptions.join(','), `Path: ${path}`, '');

    let navigationExtras: any;
    const pathParts = path.split('?');
    if (pathParts.length > 1) {
      const params = {};
      path = pathParts[0];
      const queryParts = pathParts[1].split('&');
      queryParts.forEach(qp => {
        const pairParts = qp.split('=');
        params[pairParts[0]] = pairParts[1];
      });

      navigationExtras = {
        queryParams: params
      };

      this.logger.info('app.component', 'handleNavigation',  this.subscriptionSelected, this.availableSubscriptions.join(','), `Path:${path}, QueryParams: ${JSON.stringify(params)}`, '');
    } else {
      this.logger.info('app.component', 'handleNavigation', this.subscriptionSelected, this.availableSubscriptions.join(','),  `Path:${path}`, '');
    }

    this.router.navigate([path], navigationExtras);
  }

  private Unsubscribe() {
    this.logger.info('app.component', 'unsubscribe', this.subscriptionSelected, this.availableSubscriptions.join(','), 'unsubscribing...', '');
    if (this.$subscriptions) {
      this.$subscriptions.unsubscribe();
    }
  }

  @HostListener('window:beforeunload')
  async ngOnDestroy() {
    this.Unsubscribe();
    this.logger.info('app.component', 'ngOnDestroy', this.subscriptionSelected, this.availableSubscriptions.join(','), 'saving preferences', '');
    this.storageService.saveUserPreferences();
  }

}
